// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/style.css'
import https from './assets/api/http.js'
import store from './vuex/store'
import wxApi from './assets/api/wx_sdk.js'
import VueWechatTitle from 'vue-wechat-title'
import VueMatomo from 'vue-matomo'
import { Lazyload, NavBar } from 'vant'

Vue.config.productionTip = false
Vue.prototype.$api = https
Vue.prototype.$wxApi = wxApi
Vue.use(VueWechatTitle)
Vue.use(Lazyload, {
  preLoad: 1.3,
  attempt: 3
})
// import vueSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(vueSwiper);

import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

Vue.use(VueMatomo, {
  host: '//v.jiankanghao.net/',
  siteId: 3,
  router: router,
  requireConsent: false,
  enableLinkTracking: true,
  // // 是否追踪初始页面
  // // 默认true
  trackInitialView: false,
  // // 最终的追踪js文件名
  // // 默认 'piwik'
  trackerFileName: 'matomo',
  debug: false
})

function isMobile() {
  if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;

  }
}

const is_weixin = function () {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
var iswechat = is_weixin()

function getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if(r != null) return unescape(r[2]);
	return null;

}

router.beforeEach((to, from, next) => {
  // localStorage.clear()
  let mobile = isMobile();
  if (mobile) {
    //判断页面是否需要授权
    if (to.matched.some(recode => recode.meta.auth) && to.path == '/wxbind') {
      console.log(to.query.id)
      // 判断是否是微信环境
      if (iswechat) {
        // next()
        //进行授权
        // if(store.state.unionid&&store.state.status == 3){
        //   next()
        // }else{
        var code = getQueryString("code");
        if (!code) {
          let redirectUrl = window.location.href
          // alert(redirectUrl)
          redirectUrl = encodeURIComponent(redirectUrl)
          const appid = 'wxf57920756b99e46c'
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=type%wechat_redirect`
          code = getQueryString("code");
        } else {
          // alert(code)
          // next()
          var code = getQueryString("code");
          var id = getQueryString("customer_id");
          store.commit('setcode', code)
          var params = {
            code: code,
            channel: 'h5_customer',
            customer_id:id
          }
          https.get('/oauth', {
            params
          })
            .then(function (res) {
              if(res.data.status_code == 200){
                if (typeof (res.data.data.unionid) != "undefined") {
                  //	alert("存code")
                  store.commit('setunionid', res.data.data.unionid)
                }
                if(res.data.status_code == 200){
                  // alert(res.data.data.bind_type)
                  store.commit('setstatus', res.data.data.bind_type)
                  next()
                }
                // alert(res.data.status_code)
                // alert(res.data.msg)
                // alert(res.data.data.unionid)
              }
            })
            .catch(function (err) {
              alert(err)
            })
        }
      // }
      } else {
        document.body.innerHTML = '<div style="width:100%;position: absolute;top:200px;"><p style="width:90%;margin:0 auto;text-align:center;margin-bottom:10px;">如需绑定，请长按网址复制后使用微信浏览器访问</p><p style="text-align:center;">' + window.location.href + '</p></div>';
      }
    }else if(to.matched.some(recode => recode.meta.auth) && to.path == '/read'){
      if (iswechat) {
        // next()
        //进行授权
        if(store.state.unionid){
          next()
        }else{
          // alert(11111)
        var code = getQueryString("code");
        if (!code) {
          let redirectUrl = window.location.href
          // alert(redirectUrl)
          redirectUrl = encodeURIComponent(redirectUrl)
          const appid = 'wxf57920756b99e46c'
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=type%wechat_redirect`
          code = getQueryString("code");
        } else {
          // alert(code)
          // next()
          var code = getQueryString("code");
          var id = getQueryString("customer_id");
          // store.commit('setcode', code)
          var params = {
            code: code,
            channel: 'h5',
            customer_id:id
          }
          https.get('/oauth', {
            params
          })
            .then(function (res) {
              // alert(res.data.status_code)
              if(res.data.status_code == 200){
                if (typeof (res.data.data.unionid) != "undefined") {
                  //	alert("存code")
                  store.commit('setunionid', res.data.data.unionid)
                }
                next()
                // alert(res.data.data.unionid)
              }else{
                alert(res.data.msg)
              }
            })
            .catch(function (err) {
              alert(err)
              document.body.innerHTML = err
            })
        }
      }
      } else {
        document.body.innerHTML = '<div style="width:100%;position: absolute;top:200px;"><p style="width:90%;margin:0 auto;text-align:center;margin-bottom:10px;">如需绑定，请长按网址复制后使用微信浏览器访问</p><p style="text-align:center;">' + window.location.href + '</p></div>';
      }
    } else {
      next();
    }
  } else {
    window.location.href = 'https://www.kanguji.com';
  }
})

Vue.use(NavBar)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js